import classNames from 'classnames';
import React, { memo } from 'react';
import { Link } from '@components/Link';

const StarRating = (props) => {
  const {
    reviewRating,
    reviewCount,
    itemName,
    includeAggregateRating = false,
    rootWrapperClassName = '',
  } = props;

  if (!isNaN(reviewCount) && reviewCount < 3) return null;

  const renderedStars = <Stars {...props} />;

  if (!includeAggregateRating) return renderedStars;

  return (
    <div className={classNames('rating-summary tw-font-body', rootWrapperClassName)}>
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AggregateRating',
            name: itemName,
            ratingValue: reviewRating,
            reviewCount: reviewCount,
          }),
        }}
      />
      {renderedStars}
    </div>
  );
};

const Stars = ({
  showReviewCount = true,
  isLarge = false,
  showReviewLabel,
  starsColor = '#ffb829',
  linkToReviews = true,
  hideLabels,
  reviewRating,
  reviewCount,
  fontSize = '22px',
  labelClassName = '',
  starsWrapperClassName = '',
}) => {
  const stars = (
    <div className={classNames('aks-star-rating tw-font-body', starsWrapperClassName)}>
      <div
        className='aks-stars'
        style={{ '--rating': reviewRating, '--starsColor': starsColor, fontSize }}
        aria-label={`Rating of this product is ${reviewRating} out of 5`}></div>
      <span className='visually-hidden'>Rating of this product is {reviewRating} out of 5</span>
      {!hideLabels && (
        <span className={classNames('review-count tw-font-body', labelClassName)}>
          {showReviewCount
            ? showReviewLabel
              ? `${reviewCount.toLocaleString()} Reviews`
              : `(${reviewCount.toLocaleString()})`
            : reviewRating}
        </span>
      )}
    </div>
  );

  const wrappedStars = linkToReviews ? <Link href='#reviews'>{stars}</Link> : stars;

  return <div className={classNames('stars', { large: isLarge })}>{wrappedStars}</div>;
};

export default memo(StarRating);
